export default {
  "connection": {
    "title": "Connections",
    "empty": "Aucune connexion ne correspond.",
    "filter": {
      "title": "Filter",
      "input": "Search connections",
      "all": "All Connections"
    },
    "item": {
      "connections": "{connectionCount} Connections",
      "status": "Status",
      "owner": "Added by",
      "status_tag": { "true": "Active", "false": "Error" }
    },
    "dropdown": {
      "edit": "Edit",
      "rename": "Rename",
      "delete": "Delete",
      "pause": "Pause",
      "resume": "Resume",
      "reconnect": "Reconnect"
    },
    "chooser": {
      "title": "Add a new connection",
      "ootbTitle": "Basic connectors",
      "ootbDescription": "Choose from our catalog of ready-to-use connectors.",
      "customTitle": "Universal API Connectors",
      "customDescription": "Use a BEEM-built connector.",
      "customEmpty": "No Universal API connectors are available for your workspace yet.",
      "metaCardLabel": "Meta",
      "zohoCardLabel": "Zoho Invoice",
      "linkedInCardLabel": "LinkedIn",
      "microsoftCardLabel": "Microsoft SharePoint",
      "nameModalTitle": "Name your connection",
      "nameModalPlaceholder": "Connection name",
      "nameModalSubmit": "Continue",
      "back": "Back"
    },
    "new": "New Connection",
    "unnamed": "Unnamed - {connectionId}",
    "rename_modal_dialog": {
      "title": "Rename {type} {name}",
      "name_input": "{type} new name",
      "submit_button": "Update",
      "warning_text": "Warning, this will change the name of the connection."
    },
    "pause_modal_dialog": {
      "title_pause": "Pause Connection {name}",
      "title_resume": "Resume Connection {name}",
      "description": "Pausing a connection stops data synchronization and decreases DPU consumption. You can resume the connection at any time from the connections page.",
      "submit_pause": "Pause",
      "submit_resume": "Resume"
    },
    "status": {
      "paused": "Paused"
    },
    "limit": {
      "title": "Connection limit reached",
      "message": "Your organization has reached the maximum number of connections. Please contact BEEM support to increase your limit.",
      "used": "Used:",
      "understand": "I understand"
    }
  }
};
